import React from 'react';
import './Pagination.css';

interface PaginationProps {
  totalItems: number;
  itemsPerPage: number;
  currentPage: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({ totalItems, itemsPerPage, currentPage, onPageChange }) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  if (totalPages <= 1) return null;

  const handleClick = (page: number) => {
    if (page < 1 || page > totalPages) return;
    onPageChange(page);
  };

  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  const containerStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 8,
    margin: '20px 0',
  };
  const btnStyle: React.CSSProperties = {
    padding: '6px 12px',
    border: '1px solid #003764',
    background: '#fff',
    color: '#003764',
    cursor: 'pointer',
    borderRadius: 4,
    fontSize: '1rem',
    transition: 'background 0.2s, color 0.2s',
    minWidth: 36,
    minHeight: 36,
    fontWeight: 500,
    outline: 'none',
    boxSizing: 'border-box',
  };
  const activeBtnStyle: React.CSSProperties = {
    ...btnStyle,
    background: '#003764',
    color: '#fff',
    borderColor: '#003764',
  };
  const disabledBtnStyle: React.CSSProperties = {
    ...btnStyle,
    background: '#f0f0f0',
    color: '#aaa',
    borderColor: '#003764',
    opacity: 1,
    cursor: 'not-allowed',
  };

  return (
    <nav style={containerStyle}>
      <button
        style={currentPage === 1 ? disabledBtnStyle : btnStyle}
        onClick={() => handleClick(currentPage - 1)}
        disabled={currentPage === 1}
      >
        Prev
      </button>
      {pageNumbers.map((num) => (
        <button
          key={num}
          style={num === currentPage ? activeBtnStyle : btnStyle}
          onClick={() => handleClick(num)}
        >
          {num}
        </button>
      ))}
      <button
        style={currentPage === totalPages ? disabledBtnStyle : btnStyle}
        onClick={() => handleClick(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        Next
      </button>
    </nav>
  );
};

export default Pagination;
